import NewUserPreview from "containers/NewUserPreview";
import ProjectPreview from "containers/ProjectPreview";
import moment from "moment";
import React from "react";

interface Step5FormProps {
  projectId: string;
  project: any;
}

const Step5Form: React.FC<Step5FormProps> = ({ projectId, project }) => {
  const containerStyle: React.CSSProperties = {
    width: "100%",
    borderRadius: "12px",
    backgroundColor: "#fff",
    fontFamily: "Arial, sans-serif",
    boxSizing: "border-box",
  };

  const gridStyle: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "16px",
    marginBottom: "16px",
  };

  const labelStyle: React.CSSProperties = {
    fontSize: "11px",
    color: "#555",
    marginBottom: "4px",
  };

  const valueStyle: React.CSSProperties = {
    fontSize: "12px",
    color: "#000",
    wordBreak: "break-word",
  };

  const sectionTitle: React.CSSProperties = {
    fontWeight: 600,
    fontSize: "12px",
    marginBottom: "5px",
    paddingTop: "5px",
  };

  return (
    <div className="step-form step-5" style={containerStyle}>
      <div style={gridStyle}>
        <div>
          <div style={labelStyle}>Chain</div>
          <div style={valueStyle}>{project?.chain?.name ? project?.chain?.name : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Project Name</div>
          <div style={valueStyle}>{project?.name ? project?.name : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Season</div>
          <div style={valueStyle}>{project?.project_season ? project?.project_season : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Year</div>
          <div style={valueStyle}>{project?.project_year ? project?.project_year : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Project Type</div>
          <div style={valueStyle}>{project?.project_type}</div>
        </div>
        <div>
          <div style={labelStyle}>Validation Date</div>
          <div style={valueStyle}>{project.validation_deadline? moment(project.validation_deadline).format('MM-DD-YYYY') : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Type of Comments Allowed</div>
          <div>
            <div style={valueStyle}>
              {project?.commentTypes?.length
                ? project.commentTypes.map((ct: any) => ct.name).join(", ")
                : "-"}
            </div>
          </div>
        </div>
        <div>
          <div style={labelStyle}>Number of Comments Allowed</div>
          <div style={valueStyle}>{project?.commentsAllowed ? project?.commentsAllowed : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Estimated Reset Date</div>
          <div style={valueStyle}>{project?.est_complete_date ? moment(project?.est_complete_date).format('MM-DD-YYYY') : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Project Expiration Date</div>
          <div style={valueStyle}>{project?.expires_at ? moment(project?.expires_at).format('MM-DD-YYYY') : '-'}</div>
        </div>
        <div>
          <div style={labelStyle}>Automated Announcement</div>
          <div style={valueStyle}>
            {project?.automatedAnnouncement ? "Enabled" : "Disabled"}
          </div>
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div style={sectionTitle}>Users in Project</div>
        <NewUserPreview
          prefix={"STORE2POG"}
          errorPrefixes={["USERS", "USER2STORE"]}
          projectId={projectId}
          showError={false}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <div style={sectionTitle}>Stores in Project</div>
        <ProjectPreview
          prefix={"STORE2POG"}
          errorPrefixes={["STORE2POG", "STORES"]}
          projectId={projectId}
          showError={false}
        />
      </div>
    </div>
  );
};

export default Step5Form;